<template>
  <div name="popup-trail-repayment">
    <div class="modal-body detail detail-responsive" >	
    	<div class="detail detail-responsive">

        <div class="detail-block clearfix">
          <!--Employee Code and name-->
          <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC5']['10'] }}</div>
              <div class="detail-right">
                  <div class="detail-text  width-100" id="coddesc_codempid" name="coddesc_codempid">{{ trailRepayment.codempid }} - {{ trailRepayment.desc_codempid }}</div>
              </div>
          </div>

          <!--Type of loan-->
          <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES78UC5']['30'] }}</div>
              <div class="detail-right">
                   <div class="detail-text  width-100" id="coddesc_codlon" name="coddesc_codlon">{{ trailRepayment.codlon }} - {{ trailRepayment.desc_codlon }}</div>
              </div>
          </div>
        </div>

        <div class="detail-block clearfix">
          <!--Amount Loan-->
          <div class="detail-block-float detail-block-left">
            <div class="detail-header">{{ labels['HRES78UC5']['40'] }}</div>

            <!--Max of Loan-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['50'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                        <input type="text" class="form-control input-text" id="amtmxlon" name="amtmxlon" disabled v-model="trailRepayment.amtmxlon" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                </div>
            </div>

            <!--Amount Loan-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['70'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                        <hrms-num-input  id="amtlon" name="amtlon"
                                        v-model="trailRepayment.amtlon"
                                        :numLength='9'
                                        :decimal='2'
                                        v-validate="'required'" 
                                        data-vv-name="amtlon"
                                        :class="{ 'input-error' : errors.has('amtlon') }" />                 
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                    <div class="text-error" v-show="errors.has('amtlon')">{{errors.first('amtlon')}}</div>
                </div>
            </div>

            <!--Period of loan-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['90'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                        <input type="text" class="form-control input-text" id="numlonreqyr" name="numlonreqyr" disabled v-model="trailRepayment.numlonreqyr" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['100'] }}</div>
                    </div>
                    <div class="input-group  width-100">
                        <input type="text" class="form-control input-text" id="numlonreqmth" name="numlonreqmth" disabled v-model="trailRepayment.numlonreqmth" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['110'] }}</div>
                    </div>
                </div>
            </div>
          </div>

          <!-- Interest Loan -->
          <div class="detail-block-float detail-block-right">
            <div class="detail-header">{{ labels['HRES78UC5']['120'] }}
            </div>

            <!-- Type of Interest-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['130'] }}</div>
                <div class="detail-right padding-dropdown">
                <div class="input-group  width-100">
                      <hrms-dropdown  v-model="trailRepayment.typintr" 
                                      :options="arrTypintr[nowLang]"
                                      v-validate="'required'"
                                      data-vv-value-path="inputValue"
                                      data-vv-name="typintr"
                                      :has-error="errors.has('typintr')" />
                      <div class="text-error" v-show="errors.has('typintr')">{{errors.first('typintr')}}</div>
                    </div>
                </div>
            </div>

            <!-- Rate of Interest-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['140'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                        <input  type="text" 
                                class="form-control input-text" 
                                id="rateilon" 
                                name="rateilon" 
                                v-model="trailRepayment.rateilon"
                                :disabled="trailRepayment.typintr === '2' ? false : true" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['310'] }}</div>
                    </div>
                </div>
            </div>
          </div>
        </div>

        <!-- Detail of repayment -->
        <div class="detail-block clearfix">
          <div class="detail-header">{{ labels['HRES78UC5']['330'] }}</div>

          <div class="detail-block-float detail-block-left">
            <!-- Start of mounth -->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['200'] }}</div>
                <div class="detail-right">
                      <div class="input-group  width-100">
                        <hrms-dropdown-month v-model="trailRepayment.monthst"
                                             :now-lang="nowLang"
                                             v-validate="'required'"
                                             data-vv-value-path="inputValue"
                                             data-vv-name="monthst"
                                             :has-error="errors.has('monthst')"  />
                      </div>
                      <div class="text-error" v-show="errors.has('monthst')">{{errors.first('monthst')}}</div>
                      <template v-if="trailRepayment.monthst!==''">
                        <div class="input-group  width-100">
                            <input type="text" class="form-control input-text" id="yearst" name="yearst" 
                                   v-model="trailRepayment.yearst"
                                   v-validate="'required'"
                                   data-vv-value-path="inputValue"
                                   data-vv-name="yearst"
                                   :has-error="errors.has('yearst')" />
                        </div>
                      <div class="text-error" v-show="errors.has('yearst')">{{errors.first('yearst')}}</div>
                    </template>
                    <template v-else>
                      <div class="input-group  width-100">
                            <input type="text" class="form-control input-text" id="yearst" name="yearst" v-model="trailRepayment.yearst" />
                      </div>
                    </template>
                </div>
            </div>

            <!-- Trail by -->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['230'] }}</div>
                <div class="detail-right">                   
                      <div class="input-group dropdown-nm" >
                          <select v-model="trailRepayment.typlonpay">
                            <option value="1">{{ labels['HRES78UC5']['240'] }}</option>
                            <option value="2">{{ labels['HRES78UC5']['250'] }}</option>
                          </select>
                      </div>
                </div>
            </div>

            <!-- -->
            <div class="clearfix detail-row">
                <div class="detail-left label-left"></div>
                <div class="detail-right">
                    <template v-if="trailRepayment.typlonpay === '1'">
                    <div class="input-group  width-100">
                        <input type="number" class="form-control input-text" id="qtyperiod" name="qtyperiod" 
                               v-model="trailRepayment.qtyperiod"
                               v-validate="'required|min_value:1'"
                               data-vv-value-path="inputValue"
                               data-vv-name="qtyperiod"
                               :has-error="errors.has('qtyperiod')" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['260'] }}</div>
                    </div>
                    <div class="text-error" v-show="errors.has('qtyperiod')">{{errors.first('qtyperiod')}}</div>
                    </template>
                    <template v-else>
                      <div class="input-group  width-100">
                          <input  type="text" class="form-control input-text" id="qtyperiod" name="qtyperiod" v-model="trailRepayment.qtyperiod" />
                          <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['260'] }}</div>
                      </div>
                    </template>
                </div>
            </div>
                   
            <!-- Last of repayment -->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['280'] }}</div>
                <div class="detail-right">
                    <div class="detail-text  width-100" id="amtlpay" name="amtlpay">{{ trailRepayment.amtlpay }}</div>
                </div>
            </div>
          </div>

          <div class="detail-block-float detail-block-right">

            <!--Mounth of pay Bonus-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['170'] }} {{ labels['HRES78UC5']['180'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                      <hrms-dropdown-month v-model="trailRepayment.mthbon1"
                                           :now-lang="nowLang"
                                           v-validate="'required'"
                                           data-vv-value-path="inputValue"
                                           data-vv-name="mthbon1"
                                           :has-error="errors.has('mthbon1')" />
                    </div>
                    <div class="text-error" v-show="errors.has('mthbon1')">{{errors.first('mthbon1')}}</div>
                </div>
            </div>
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['170'] }} {{ labels['HRES78UC5']['190'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                      <hrms-dropdown-month v-model="trailRepayment.mthbon2"
                                           :now-lang="nowLang"
                                           v-validate="'required'"
                                           data-vv-value-path="inputValue"
                                           data-vv-name="mthbon2"
                                           :has-error="errors.has('mthbon2')" />
                    </div>
                    <div class="text-error" v-show="errors.has('mthbon2')">{{errors.first('mthbon2')}}</div>
                </div>
            </div>

            <!--Rate of bonus-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['210'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                      <hrms-num-input class="width-75" 
                                      v-model="trailRepayment.ratebon"
                                      :numLength='9'
                                      :decimal='2'
                                      v-validate="'required'" 
                                      name="ratebon"
                                      data-vv-name="ratebon"
                                      :has-error="errors.has('ratebon')"  />
                      <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['220'] }}</div>
                    </div>
                    <div class="text-error" v-show="errors.has('ratebon')">{{errors.first('ratebon')}}</div>
                </div>
            </div>

            <!--Normal pay off-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['270'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                        <hrms-num-input class="width-75" 
                                        v-model="trailRepayment.amtpnor"
                                        :numLength='9'
                                        :decimal='2'
                                        v-validate="`${trailRepayment.typlonpay === '2' ? 'required' : ''}`"
                                        name="amtpnor"
                                        data-vv-name="amtpnor"
                                        :has-error="errors.has('amtpnor')"  />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                    <div class="text-error" v-show="errors.has('amtpnor')">{{errors.first('amtpnor')}}</div>
                </div>
            </div>

            <!--Bonus pay off Loan-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['290'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                        <hrms-num-input class="width-75" 
                                        v-model="trailRepayment.amtpbon"
                                        :numLength='9'
                                        :decimal='2'
                                        name="amtpbon"
                                        data-vv-name="amtpbon"
                                        :has-error="errors.has('amtpbon')"  />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                    <div class="text-error" v-show="errors.has('amtpbon')">{{errors.first('amtpbon')}}</div>
                </div>
            </div>

              <!--Percent (Salary+Bonus)-->
            <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC5']['300'] }}</div>
                <div class="detail-right">
                    <div class="input-group  width-100">
                        <input type="text" class="form-control input-text" id="pctsalbo" name="pctsalbo" disabled v-model="trailRepayment.pctsalbo" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                </div>
            </div>
          </div>
        </div>

        <div class="clearfix">
          <button type="button" data-toggle="modal" class="bg-dark-gray btn"  @click="setShowTrailRepayment(!showTrailRepayment)" >
            <i class="fa fa-chevron-circle-left"></i> {{ labelsButton['back'] }}
          </button>
          <button type="button" data-toggle="modal" class="bg-dark-gray btn"  @click="processTable()" >
            <i class="fa fa-spinner"></i> {{ labelsButton['process'] }}
          </button>
        </div>

        <div v-if="showProcessTable">
          <hrms-table :columns="columnsProcessTable" :data="tableProcess" />
        </div>
    	</div>			
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup-trail-repayment',
  props: [ 'showTrailRepayment', 'trailRepayment', 'labels', 'labelsButton', 'nowLang', 'arrTypintr', 'setShowTrailRepayment', 'toggleProcessTable', 'showProcessTable', 'columnsProcessTable', 'tableProcess', 'indexSelected' ],
  watch: {
    'trailRepayment.typintr' () {
      switch (this.trailRepayment.typintr) {
        case '1':
          this.trailRepayment.rateilon = this.trailRepayment.rateilon1
          break
        case '2':
          this.trailRepayment.rateilon = '0.00'
          break
        case '3':
          this.trailRepayment.rateilon = this.trailRepayment.rateilon3
          break
        case '4':
          this.trailRepayment.rateilon = this.trailRepayment.rateilon4
          break
        default:
          break
      }
    },
    'tableProcess.rows' () {
      this.tableProcess.rows.map((row) => {
        this.trailRepayment.pctsalbo = row.pctsalbo
        this.trailRepayment.amtpnor = row.amtpnor
        this.trailRepayment.amtlpay = row.amtlpay
        if (this.trailRepayment.typlonpay === '1') {
          this.trailRepayment.amtpbon = '0.00'
        } else {
          this.trailRepayment.amtpbon = row.amtpbon
        }
      })
    }
  },
  methods: {
    processTable () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.toggleProcessTable()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// popupTrialRepayment.vue?a1d51236